"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../types/EventType");
var Id_1 = require("../types/Id");
var AbstractEvent_1 = require("./AbstractEvent");
var HomeDetailViewedEvent = (function (_super) {
    __extends(HomeDetailViewedEvent, _super);
    function HomeDetailViewedEvent(homeId) {
        var _this = _super.call(this) || this;
        _this.props = new HomeDetailViewedEventProperties(new Id_1.Id(homeId));
        return _this;
    }
    HomeDetailViewedEvent.prototype.getType = function () {
        return EventType_1.EventType.HomeDetailViewed;
    };
    return HomeDetailViewedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.HomeDetailViewedEvent = HomeDetailViewedEvent;
var HomeDetailViewedEventProperties = (function () {
    function HomeDetailViewedEventProperties(home_id) {
        this.home_id = home_id;
    }
    return HomeDetailViewedEventProperties;
}());
//# sourceMappingURL=HomeDetailViewedEvent.js.map